module.exports = __webpack_public_path__ + "img/fengxiang.f310b01d.png";